// TODO: rename module
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stSelectFilterComponent from './stSelectFilter.component';

const stSelectFilterModule = angular.module('stSelectFilter', [
    uiRouter
  ])
  .component('stSelectFilter', stSelectFilterComponent)
  .name;

export default stSelectFilterModule;



// WEBPACK FOOTER //
// ./client/app/common/stSelectFilter/stSelectFilter.js